<script>
import { ref, defineComponent, onMounted } from "@vue/composition-api";
import AppStepper from "../atoms/AppStepper.vue";
import TheInnerToolbar from "@/components/organisms/TheInnerToolbar.vue";
import AppDialog from "@/components/atoms/AppDialog.vue";
import billingEditForm from "@/constants/form/billing-edit-form";
import { deepCopyObject } from "@/helpers/deep-copy-object";

export default defineComponent({
  name: "BillingEditTemplate",
  components: { AppStepper, AppDialog, TheInnerToolbar },
  props: {
    originalBilling: {
      type: Object,
      default: () => ({}),
    },
    memberName: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const dialog = ref(false);
    const step = ref(1);
    const form = ref({});
    const formName = ref("BillingEdit");
    const formKeys = ref({
      1: "1",
    });
    const stepList = ref(deepCopyObject(billingEditForm));

    const changeStep = (payload) => {
      step.value = payload;
    };

    const handleChange = (payload) => {
      let keys = Object.keys(stepList.value);
      keys.forEach((key) => {
        if (formKeys.value[key] != undefined) {
          let fieldKeys = Object.keys(
            stepList.value[key][formKeys.value[key]].form
          );
          fieldKeys.forEach((field) => {
            stepList.value[key][formKeys.value[key]].form[field].value =
              payload[stepList.value[key][formKeys.value[key]].name][field];
          });
        }
      });
    };

    const populateForm = () => {
      let keys = Object.keys(stepList.value[1][1].form);
      keys.forEach((key) => {
        stepList.value[1][1].form[key].value = props.originalBilling[key];
      });
    };

    const cancelConfirm = () => {
      dialog.value = false;
      emit("cancel");
    };

    const cancelCancel = () => {
      dialog.value = false;
    };

    const cancel = () => {
      dialog.value = true;
    };

    const submit = (payload) => {
      emit("submit", payload["billing-edit"]);
    };

    // Add onMounted hook
    onMounted(() => {
      populateForm();
    });

    return {
      dialog,
      step,
      form,
      formName,
      formKeys,
      stepList,
      changeStep,
      handleChange,
      populateForm,
      cancelConfirm,
      cancelCancel,
      cancel,
      submit,
    };
  },
});
</script>

<template>
  <section class="inner-form section-container">
    <the-inner-toolbar
      title="Editar Mensalidade"
      :isForm="true"
      @cancel="cancel"
    />

    <app-stepper
      @changeStep="changeStep"
      :currentStep="step"
      :stepList="stepList"
      :formKeys="formKeys"
      @change="handleChange"
      @cancel="cancel"
      @submit="submit"
    />
    <app-dialog
      :dialog="dialog"
      title="Confirmação"
      text="Tem certeza que deseja cancelar? Os dados editados serão perdidos."
      buttonCancel="Não"
      buttonConfirm="Sim"
      @clickConfirm="cancelConfirm"
      @clickCancel="cancelCancel"
    />
  </section>
</template>

<style lang="scss" scoped>
.inner-form.section-container {
  .v-stepper,
  .v-stepper__items,
  .v-stepper__content,
  .v-stepper__wrapper,
  .app-card {
    min-height: calc((var(--vh) * 100) - 144px) !important;
    @media screen and (min-width: 1000px) {
      min-height: calc((var(--vh) * 100) - 200px) !important;
    }
  }
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-container {
  height: 100%;
  width: 100%;
}

.page-subtitle {
  text-align: center;
  font-weight: 500;
  width: 80%;
  margin-bottom: 3.5em !important;
  font-size: var(--font-small);
  margin: 0 auto;
  color: var(--gray-medium);
}
</style>
@/helpers/deep-copy-object
